export const ROUTES = {
  LOGIN: '/',
  DASHBOARD: '/dashboard',
  APPOINTMENT: '/appointments',
  SCHEDULE: '/schedule',
  OFFICE_SCHEDULE: '/office-schedule',
  PRACTICE_PROFILE: '/practice',
  PRACTITIONER: '/practitioners',
  SERVICE: '/services',
  ONLINE_SCHEDULER: '/online-scheduler',
  ONLINE_SCHEDULING_REPORT: '/online-scheduling-report',
  USER: '/users',
  SYNC: '/sync',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  SETUP_ACCOUNT: '/setup-account',
  INSURANCE: '/insurance',
  PAYMENT_AUTHORIZATIONS: '/payment-authorizations',
  INTEGRATIONS: '/integrations',
  REPORTING_API: '/reporting-api',
};

export const ADMIN_ROUTES = {
  DASHBOARD: '/admin/dashboard',
  INSIGHT: '/admin/insights',
  ONLINE_SCHEDULING_REPORT: '/admin/online-scheduling-report',
  APPOINTMENT: 'admin/appointments',
  PRACTICE: '/admin/practices',
  USER: '/admin/users',
  GROUP_USER: '/admin/group-users',
  SERVICE: '/admin/services',
};
